import BaseAPI from './BaseAPI';
import ServiceApiUrlsStore from '../stores/ServiceApiUrlsStore';

class SyncAPIWrapper {
  constructor(api) {
    this.api = api;
  }

  status(organizationId, number) {
    return this.api.get(`/api/organization/${organizationId}/status?num=${number}`)
      .then(data => data.body);
  }
}

class SyncAPI extends BaseAPI {
  constructor(token) {
    super(ServiceApiUrlsStore.getSyncServiceUrl(), token);
    this.syncs = new SyncAPIWrapper(this);
  }
}

export default SyncAPI;
